import { render, staticRenderFns } from "./SitioRamsarParaguai.vue?vue&type=template&id=1f9e507f&lang=pug"
import script from "./SitioRamsarParaguai.vue?vue&type=script&lang=js"
export * from "./SitioRamsarParaguai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports